import React from "react";
import { Link } from "react-router-dom";
import Filter from "../components/filter"

class ClientesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  render() {
    return (
      <div >
        <h1 className='text-center'>Clientes</h1>
        <div className="d-flex justify-content-center">
          <Link className="btn btn-primary btn-sm mr-3" to="/clients/create">
            Cadastrar
          </Link>
        </div>
        <Filter onClick={item => {
          window.location.href = `/clients/${item.id}`
        }} />

      </div>
    );
  }
}

export default ClientesList;



// WEBPACK FOOTER //
// ./src/components/pages/clients/list/index.jsx